export const SITE = {
  name: "Pickleballgearz",
  shortName: "Pickleballgearz",
  phone: "+92 300 123 4567",
  phoneLink: "tel:+923001234567",
  whatsappLink:
    "https://wa.me/923001234567?text=Hi%20Pickleballgearz%2C%20I%27d%20like%20a%20quote%20for%20pickleball%20products.",
  email: "info@pickleballgearz.com",
  secondaryEmail: "pickleballgearz01@gmail.com",
  address: "Sialkot 51310, Punjab, Pakistan",
  copyright: "© 2026 Pickleballgearz",
};

const px = (id) => `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg`;

export const IMAGES = {
  carbon: px(17370583),
  paddle1: px(17299530),
  paddle2: px(19642670),
  factory: px(12951630),
  worker: px(6525848),
};

export const pimg = (url, w = 1200, h = 1200) => {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return `${url}?auto=compress&cs=tinysrgb&w=${w}&h=${h}&fit=crop`;
  }
  const cleanUrl = url.startsWith("/") ? url : `/${url}`;
  if (typeof window !== "undefined" && window.location) {
    const host = window.location.hostname;
    if (host !== "localhost" && host !== "127.0.0.1" && !host.startsWith("192.168.")) {
      return `${window.location.origin}${cleanUrl}`;
    }
  }
  const backend = (process.env.REACT_APP_BACKEND_URL || "http://localhost:8000").replace(/\/+$/, "");
  return `${backend}${cleanUrl}`;
};

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About Us" },
  { to: "/products", label: "Products" },
  { to: "/b2b", label: "B2B" },
  { to: "/blog", label: "Blog" },
  { to: "/size-chart", label: "Size Chart" },
  { to: "/moq", label: "MOQ" },
  { to: "/contact", label: "Contact Us" },
];

/**
 * Ensures 'Pickleball' is preset in front of category names (client requirement).
 */
export const formatCategoryName = (name) => {
  if (!name) return "";
  const trimmed = String(name).trim();
  if (!trimmed || trimmed.toLowerCase() === "all") return trimmed;
  if (/^pickleball\b/i.test(trimmed)) return trimmed;
  return `Pickleball ${trimmed}`;
};
